// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import INITIAL_STATE from '../orderCreation/initialState.json';

export type ServiceRequestDataType = Readonly<typeof INITIAL_STATE>;

export function saveSafetyFormDataReducer(
    state: any,
    { payload }: any
): ServiceRequestDataType {
    if (payload) {
        return {
            ...state,
            safetyIssueInfo: payload,
            isValid: true,
        };
    }

    return INITIAL_STATE;
}

export function _getSafetyFormDataFail(state: any) {
    return { ...state, isValid: false };
}
